module.exports = __webpack_public_path__ + "static/media/BULA.a4f69729.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/BULA.jpg
// module id = 1714
// module chunks = 1